import { Box, Typography } from '@mui/material';

import { useAssistant } from '@core/assistant/providers/Provider';
import { SCREENS } from '@core/assistant/interfaces';
import { PollyLanguage, voicesByLanguage } from '@constants/polly';
import ModalBox from '@core/assistant/ModalBox';
import { useStyles } from './styles';

const LANGUAGE_DISPLAY: Record<PollyLanguage, { flag: string; code: string }> =
  {
    [PollyLanguage.ARABIC]: { flag: '🇸🇦', code: 'AR' },
    [PollyLanguage.CHINESE]: { flag: '🇨🇳', code: 'ZH' },
    [PollyLanguage.CZECH]: { flag: '🇨🇿', code: 'CZ' },
    [PollyLanguage.DANISH]: { flag: '🇩🇰', code: 'DK' },
    [PollyLanguage.DUTCH]: { flag: '🇳🇱', code: 'NL' },
    [PollyLanguage.ENGLISH]: { flag: '🇬🇧', code: 'EN' },
    [PollyLanguage.FINNISH]: { flag: '🇫🇮', code: 'FI' },
    [PollyLanguage.FRENCH]: { flag: '🇫🇷', code: 'FR' },
    [PollyLanguage.GERMAN]: { flag: '🇩🇪', code: 'DE' },
    [PollyLanguage.HINDI]: { flag: '🇮🇳', code: 'HI' },
    [PollyLanguage.ICELANDIC]: { flag: '🇮🇸', code: 'IS' },
    [PollyLanguage.ITALIAN]: { flag: '🇮🇹', code: 'IT' },
    [PollyLanguage.JAPANESE]: { flag: '🇯🇵', code: 'JP' },
    [PollyLanguage.KOREAN]: { flag: '🇰🇷', code: 'KR' },
    [PollyLanguage.NORWEGIAN]: { flag: '🇳🇴', code: 'NO' },
    [PollyLanguage.POLISH]: { flag: '🇵🇱', code: 'PL' },
    [PollyLanguage.PORTUGUESE]: { flag: '🇵🇹', code: 'PT' },
    [PollyLanguage.ROMANIAN]: { flag: '🇷🇴', code: 'RO' },
    [PollyLanguage.RUSSIAN]: { flag: '🇷🇺', code: 'RU' },
    [PollyLanguage.SPANISH]: { flag: '🇪🇸', code: 'ES' },
    [PollyLanguage.SWEDISH]: { flag: '🇸🇪', code: 'SE' },
    [PollyLanguage.TURKISH]: { flag: '🇹🇷', code: 'TR' },
    [PollyLanguage.WELSH]: { flag: '🏴󠁧󠁢󠁷󠁬󠁳󠁿', code: 'CY' },
  };

const LanguageSettingsScreen = () => {
  const classes = useStyles();
  const {
    navigate,
    setOpen,
    setNavigationHistory,
    availableLanguages,
    audioLanguage,
    setAudioLanguage,
  } = useAssistant();

  // Only show languages that exist in voicesByLanguage (polly-supported)
  const languages = availableLanguages.filter((lang) => voicesByLanguage[lang]);

  return (
    <ModalBox
      title={<Typography sx={classes.title}>Settings</Typography>}
      onClose={() => {
        setOpen(false);
        setNavigationHistory([]);
        navigate(SCREENS.DEFAULT);
      }}
      onBack={() => navigate(SCREENS.DEFAULT, true)}
    >
      <Typography sx={classes.sectionLabel}>AUDIO LANGUAGE</Typography>
      <Box sx={classes.grid}>
        {languages.map((lang) => {
          const display = LANGUAGE_DISPLAY[lang];

          if (!display) {
            return null;
          }

          const isSelected = audioLanguage === lang;

          return (
            <Box
              key={lang}
              sx={classes.tile(isSelected)}
              onClick={() => setAudioLanguage(lang)}
            >
              <Typography sx={classes.flag}>{display.flag}</Typography>
              <Typography sx={classes.code}>{display.code}</Typography>
            </Box>
          );
        })}
      </Box>
    </ModalBox>
  );
};

export default LanguageSettingsScreen;
